<template>
  <div class="agent" :style="{ marginBottom: `${marginBottom}px` }">
    <img alt="" :src="avatar" :style="{ width: `${imgSize}px`, height: `${imgSize}px` }" />
    <div
      class="name"
      :style="{
        fontSize: `${fontSize}px`,
        lineHeight: `${lineHeight}px`,
        color: fontColor,
        fontWeight: fontWeight
      }"
    >
      {{ name }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  avatarIndex: {
    type: [Number, String],
    default: 1
  },
  name: {
    type: String,
    default: ''
  },
  imgSize: {
    type: Number,
    default: 24
  },
  fontSize: {
    type: Number,
    default: 14
  },
  fontColor: {
    type: String,
    default: '#969799'
  },
  lineHeight: {
    type: Number,
    default: 20
  },
  marginBottom: {
    type: Number,
    default: 8
  },
  fontWeight: {
    type: [Number, String],
    default: 'normal'
  }
})
const avatar = require(`@/assets/ai-avatar/ai-avatar-2x-${props.avatarIndex}.png`)
</script>

<style lang="scss" scoped>
.agent {
  display: flex;
  align-items: center;

  img {
    border-radius: 50%;
    margin-right: 8px;
    box-shadow: 0px 0px 4px 0px rgba(56, 47, 220, 0.2);
  }
  .name {
    font-family: PingFang SC;
  }
}
</style>
